import React from 'react';
import classNames from 'classnames';
import * as styles from './card.module.sass';
import { CardProps } from './props.types';

export const Card = (props: CardProps) => {
  const { children, className, color = '', heading_left = false, section = '' } = props;

  const classProps: string = classNames(
    styles.card,
    styles[color],
    styles[section],
    { [styles.card_heading_left]: heading_left },
    className,
  );

  return <div className={classProps}>{children}</div>;
};
